import { render, staticRenderFns } from "./ListChannels.vue?vue&type=template&id=813b101a&"
import script from "./ListChannels.vue?vue&type=script&lang=js&"
export * from "./ListChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports